module.exports = __webpack_public_path__ + "img/13.0-panel.c9fffe3f.jpg";